module.exports = __webpack_public_path__ + "img/trees-shrubs.56f5295a.jpg";